import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Form } from "antd";
import Modal from "antd/es/modal/Modal";
import { onUpdateSelectedItemCategory, onCreateItemCategory } from "../../../redux/actions";
import ItemCategoryForm from "./CreateCategoryForm";

const CreateItemCategory = (props) => {
  const dispatch = useDispatch();
  const { isAddItemCategory, handleAddCategoryClose, selectedItemCategory, onUpdateItemCategory } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    let attribute_name = [];

    selectedItemCategory?.attribute_info?.forEach((item, index) => {
      attribute_name.push(item?.name);
    });
    form.setFieldValue("attribute_name", attribute_name);
    form.setFieldValue("use_fabric_interlining_store", selectedItemCategory?.use_fabric_interlining_store ?? "Yes");
  }, [selectedItemCategory, form]);

  const handleCloseModal = () => {
    form.resetFields();
    handleAddCategoryClose();
  };

  const buildAttributePayload = (values) => {
    const attributeValues = Array.isArray(values?.attribute_name) ? values.attribute_name : [];
    const attribute_names = [];
    const attribute_ids = [];

    attributeValues.forEach((attribute) => {
      attribute_names.push(attribute);
      attribute_ids.push("");
    });

    return { attribute_names, attribute_ids };
  };
  // const onChangeCheckboxcategory_wise = (e) => {
  //     form.setFieldsValue({
  //         category_wise_view_in_pi: e.target.checked,
  //     });
  // };

  return (
    <>
      <Modal
        forceRender
        open={isAddItemCategory}
        title={selectedItemCategory ? `Update Item Category` : "Create New Item Category"}
        okText={"Save"}
        cancelText="Discard"
        cancelButtonProps={{ type: "danger" }}
        onCancel={handleCloseModal}
        onOk={async () => {
          try {
            const values = await form.validateFields();
            const { attribute_names, attribute_ids } = buildAttributePayload(values);

            const payload = selectedItemCategory
              ? {
                  id: selectedItemCategory.id,
                  name: values.name,
                  category_unique_id: selectedItemCategory.category_unique_id,
                  status: values.status,
                  attribute_name: attribute_names,
                  attribute_id: attribute_ids,
                  use_fabric_interlining_store: values?.use_fabric_interlining_store,
                }
              : {
                  name: values.name,
                  category_unique_id: values.category_unique_id,
                  attribute_name: attribute_names,
                  attribute_id: attribute_ids,
                  status: values.status,
                  use_fabric_interlining_store: values?.use_fabric_interlining_store,
                };

            const response = selectedItemCategory
              ? await dispatch(onUpdateSelectedItemCategory(payload))
              : await dispatch(onCreateItemCategory(payload));

            if (response?.data?.code === 200) {
              props.refetch();
              handleCloseModal();
            }
          } catch (error) {
            // Keep modal open so the user can correct and resave.
          }
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          preserve={false}
          initialValues={{
            status: selectedItemCategory ? selectedItemCategory.status : "active",
            name: selectedItemCategory ? selectedItemCategory.name : "",
            use_fabric_interlining_store: selectedItemCategory?.use_fabric_interlining_store ?? "Yes",
            // category_wise_view_in_pi:
            //   selectedItemCategory?.category_wise_view_in_pi === "Yes"
            //     ? true
            //     : false,
          }}
        >
          <ItemCategoryForm
          // onChangeCheckboxcategory_wise={onChangeCheckboxcategory_wise}
          />
        </Form>
      </Modal>
    </>
  );
};

export default CreateItemCategory;
